import { render, staticRenderFns } from "./RipaPageContainer.vue?vue&type=template&id=1ee23d58&v-if=dataReady"
import script from "./RipaPageContainer.vue?vue&type=script&lang=js"
export * from "./RipaPageContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports